import { atom } from 'jotai';

const isSearchOpen = atom(false);

export default isSearchOpen;
